var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.546,
    height: 22.017,
    viewBox: "0 0 19.546 22.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cash",
    transform: "translate(22.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41248",
    "data-name": "Group 41248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41248-2",
    "data-name": "Group 41248",
    transform: "translate(-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M111.16,374.547c.228.069.478.134.749.193.325.071.681.134,1.063.186a18.67,18.67,0,0,0,4.732,0c.383-.051.738-.115,1.063-.186q.406-.089.749-.193c1.029-.312,1.607-.707,1.607-1.03,0-.636-2.254-1.559-5.785-1.559s-5.785.923-5.785,1.559C109.553,373.839,110.131,374.235,111.16,374.547Z",
    transform: "translate(-109.553 -371.958)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M111.16,707.7q-.308-.085-.585-.185c-.169-.061-.329-.126-.478-.194a3.828,3.828,0,0,1-.545-.3v1.711c0,.322.578.717,1.607,1.029.228.069.478.134.749.193.325.071.681.135,1.063.186a17.808,17.808,0,0,0,2.366.151c.378,0,.738-.012,1.085-.032v-1.3a1.221,1.221,0,0,1,.331-.816c-.466.034-.941.053-1.416.053A16.359,16.359,0,0,1,111.16,707.7Z",
    transform: "translate(-109.553 -701.304)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M111.16,1223.923c-.206-.057-.4-.119-.585-.184-.169-.061-.329-.126-.478-.195a3.832,3.832,0,0,1-.545-.3v1.711c0,.636,2.254,1.559,5.785,1.559.377,0,.738-.011,1.085-.031v-2.094c-.359.02-.722.03-1.085.03A16.351,16.351,0,0,1,111.16,1223.923Z",
    transform: "translate(-109.553 -1208.719)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M111.16,537.815c.228.069.478.134.748.193.325.071.681.134,1.064.186a18.655,18.655,0,0,0,4.732,0c.383-.052.738-.115,1.064-.186q.406-.089.748-.193c1.029-.312,1.607-.708,1.607-1.03v-1.711a3.878,3.878,0,0,1-.545.3c-.149.069-.308.133-.478.194-.185.066-.38.128-.584.185a17.885,17.885,0,0,1-8.356,0q-.308-.085-.585-.185c-.169-.06-.329-.126-.478-.194a3.875,3.875,0,0,1-.545-.3v1.711C109.553,537.107,110.131,537.5,111.16,537.815Z",
    transform: "translate(-109.553 -532.288)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M111.16,879.84q-.308-.085-.585-.184c-.169-.061-.329-.126-.478-.195a3.857,3.857,0,0,1-.545-.3v1.711c0,.636,2.254,1.559,5.785,1.559.377,0,.738-.011,1.085-.031V880.3c-.359.02-.722.03-1.085.03A16.335,16.335,0,0,1,111.16,879.84Z",
    transform: "translate(-109.553 -870.505)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M111.16,1051.785q-.308-.085-.585-.184c-.169-.061-.329-.126-.478-.195a3.808,3.808,0,0,1-.545-.3v1.711c0,.636,2.254,1.56,5.785,1.56.377,0,.738-.011,1.085-.031v-2.094c-.359.02-.722.03-1.085.03A16.34,16.34,0,0,1,111.16,1051.785Z",
    transform: "translate(-109.553 -1039.516)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M571.849,1408.793c-.143.069-.3.134-.459.195s-.365.128-.562.184a16.556,16.556,0,0,1-8.035,0q-.3-.085-.562-.184c-.163-.061-.316-.126-.459-.195a3.7,3.7,0,0,1-.513-.3l-.011-.007v1.711c0,.636,2.167,1.56,5.563,1.56s5.564-.924,5.564-1.56v-1.711l-.011.007A3.628,3.628,0,0,1,571.849,1408.793Z",
    transform: "translate(-553.828 -1390.744)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M571.813,1064.7q-.214.1-.459.194c-.136.051-.279.1-.427.143-.046.014-.089.029-.135.042a12.771,12.771,0,0,1-2.163.4,17.788,17.788,0,0,1-3.709,0,12.76,12.76,0,0,1-2.163-.4l-.141-.043c-.146-.045-.287-.091-.421-.141-.162-.061-.316-.126-.46-.194a3.719,3.719,0,0,1-.512-.3l-.012-.007v1.711c0,.311.519.689,1.443,1l.1.034c.219.069.46.134.72.193.24.054.5.1.775.146.083.013.162.028.248.039.136.019.278.036.421.051a17.287,17.287,0,0,0,3.708,0c.143-.016.285-.032.421-.051.086-.012.165-.026.248-.039.273-.044.535-.092.775-.145.26-.06.5-.125.72-.194l.1-.032c.928-.307,1.449-.687,1.449-1V1064.4l-.011.007A3.667,3.667,0,0,1,571.813,1064.7Z",
    transform: "translate(-553.793 -1052.52)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M571.849,1236.848c-.143.069-.3.134-.459.195-.134.05-.275.1-.421.141-.047.015-.093.03-.142.044a12.792,12.792,0,0,1-2.163.4,17.832,17.832,0,0,1-3.709,0,12.8,12.8,0,0,1-2.163-.4c-.049-.014-.094-.029-.142-.044-.145-.044-.287-.091-.421-.141-.163-.061-.316-.126-.459-.195a3.641,3.641,0,0,1-.517-.3l-.007,0v1.711c0,.311.518.689,1.442,1a15.355,15.355,0,0,0,8.242,0c.925-.307,1.442-.686,1.442-1v-1.711l-.011.007A3.659,3.659,0,0,1,571.849,1236.848Z",
    transform: "translate(-553.828 -1221.736)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M571.849,892.753q-.215.1-.459.194c-.134.049-.275.1-.42.141l-.142.044a12.769,12.769,0,0,1-2.163.4,17.788,17.788,0,0,1-3.709,0,12.774,12.774,0,0,1-2.163-.4l-.141-.044c-.146-.045-.287-.091-.421-.141-.163-.061-.316-.126-.459-.194a3.666,3.666,0,0,1-.519-.3l-.005,0v1.711c0,.31.518.69,1.443,1l.1.034c.219.069.46.134.72.193.238.054.5.1.77.145.085.013.166.028.253.041.136.019.278.035.421.051a17.332,17.332,0,0,0,3.709,0c.143-.015.285-.032.421-.051.086-.012.165-.027.248-.04.273-.043.535-.091.775-.146.26-.059.5-.125.719-.193l.1-.034c.924-.306,1.443-.685,1.443-1V892.45l-.012.007A3.647,3.647,0,0,1,571.849,892.753Z",
    transform: "translate(-553.828 -883.507)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M568.664,729.432a17.492,17.492,0,0,0-3.709,0c-2.31.255-3.709.95-3.709,1.461,0,.31.517.688,1.439.995l.106.035c.219.069.46.134.72.193.239.054.5.1.771.145.084.013.164.028.251.04.136.019.278.035.421.051a17.353,17.353,0,0,0,3.709,0c.143-.016.285-.032.421-.051.087-.012.167-.027.252-.04.271-.044.532-.091.771-.145.26-.059.5-.124.72-.193l.1-.033c.925-.307,1.445-.686,1.445-1C572.374,730.381,570.974,729.686,568.664,729.432Z",
    transform: "translate(-553.828 -723.173)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon);
export default __webpack_public_path__ + "static/media/header-icon.32121a47358cbf1edc2b942c85165c54.svg";
export { ForwardRef as ReactComponent };